import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { LANGS, makeT } from "@/i18n/translations";

const LanguageContext = createContext(null);
const STORAGE_KEY = "nsot_lang";

function safeGet(key) {
  try {
    if (typeof window === "undefined" || !window.localStorage) return null;
    return window.localStorage.getItem(key);
  } catch (e) { return null; }
}
function safeSet(key, value) {
  try {
    if (typeof window === "undefined" || !window.localStorage) return;
    window.localStorage.setItem(key, value);
  } catch (e) { /* Safari private mode or quota */ }
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => safeGet(STORAGE_KEY) || "en");

  useEffect(() => {
    const meta = LANGS.find((l) => l.code === lang) || LANGS[0];
    try {
      document.documentElement.setAttribute("lang", meta.code);
      document.documentElement.setAttribute("dir", meta.dir);
    } catch (e) { /* no-op */ }
    safeSet(STORAGE_KEY, lang);
  }, [lang]);

  const value = useMemo(() => {
    const meta = LANGS.find((l) => l.code === lang) || LANGS[0];
    return { lang, setLang: setLangState, t: makeT(lang), dir: meta.dir, langs: LANGS };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
